import type { ReactNode } from "react";
import { cn } from "../../lib/utils";
import { domainClasses, type Domain } from "./domains";

export interface EyebrowProps {
  children: ReactNode;
  /** `action` = rust; a domain = that domain's ink. */
  tone?: "action" | "muted" | Domain;
  as?: "p" | "span" | "div";
  className?: string;
}

/** Geist Mono 12, uppercase, tracking 0.12em. */
export function Eyebrow({
  children,
  tone = "action",
  as: Tag = "p",
  className,
}: EyebrowProps) {
  return (
    <Tag
      className={cn(
        "font-mono text-xs font-semibold uppercase tracking-[0.12em]",
        tone === "action"
          ? "text-caire-action"
          : tone === "muted"
            ? "text-caire-muted"
            : domainClasses[tone].ink,
        className,
      )}
    >
      {children}
    </Tag>
  );
}
